import { useLastNonNull } from "@lib/Hooks"
import { Button, ButtonType, ButtonTheme } from "@ui/common/buttons/Button"
import {
    Modal,
    ModalBody,
    ModalButtons,
    ModalContent,
    ModalHeader,
    ModalHeaderTitle,
} from "@ui/common/Modal"
import React from "react"
import { ServiceItemForm } from "@model/serviceRequests/ServiceItemForm"
import { ImageUrls } from "@ui/common/images/ImageUrls"
import { Grid } from "@ui/common/grids/Grid"
import { FormField } from "@ui/common/form/FormField"
import { TextArea } from "@ui/common/form/TextArea"
import { ServiceItemViewModel } from "@ui/workRequests/ServiceItemViewModel"
import { useBlocCoordinator } from "@lib/bloc/hooks"
export function ServiceItemDeclineModal({
    viewModel,
    onCancel,
    onConfirm
}: {
    viewModel: ServiceItemViewModel | null
    onCancel: () => void
    onConfirm: (serviceItemId: number) => void
}): JSX.Element {
    if (!viewModel) {
        return <Modal isVisible={false} />
    }

    const [state] = useBlocCoordinator(() => viewModel)
    const data = useLastNonNull(state)

    return (
        <Modal isVisible={viewModel !== null} useContentTag={true} onClose={onCancel}>
            <ModalContent>
                <div className="service-item-decline-modal">
                    <ModalHeader>
                        <ModalHeaderTitle>
                            <img src={ImageUrls.Trash} alt="Delete" className="delete-icon" />
                            Decline Service Work
                        </ModalHeaderTitle>
                    </ModalHeader>
                    <ModalBody>
                        <Grid columns={1}>
                            <div>
                                Please provide a reason for declining this service work. This will help track why the work was not completed.
                            </div>
                            <FormField label="Service Item">
                                <div className="readonly-value">{data?.name || "-"}</div>
                            </FormField>
                            <FormField label={"Reason*"}>
                                <TextArea
                                    value={state.dismissedReason}
                                    onChange={(value) => viewModel.updateField("dismissedReason", value)}
                                    maxLength={250}
                                />
                            </FormField>
                        </Grid>
                    </ModalBody>
                    <ModalButtons>
                        <Button label="Cancel" type={ButtonType.Outlined} onClick={onCancel} />
                        <Button
                            label="Decline Work"
                            type={ButtonType.Contained}
                            theme={ButtonTheme.Light}
                            iconUrl={ImageUrls.Trash}
                            isEnabled={(state.dismissedReason ?? "").trim() !== ""}
                            onClick={() => onConfirm(state.uiElementId)}
                            iconPosition="left"
                        />
                    </ModalButtons>
                </div>
            </ModalContent>
        </Modal>
    )
}
